<template>
  <div class="tasklist-drawers" data-testid="tasklist__drawers">
    <BulkLinkBotDrawer
      v-if="isDrawerMounted('bulklinkbotdialog')"
      :visible="bulklinkbotdialog"
      @update:visible="bulklinkbotdialog = $event"
      :bot-name="$constants.BOT_NAME"
      :selected-bot.sync="selectedbot"
      :bot-list="botList"
      :selected-tasks="selectedTasks"
      :lease-schedule-items="leaseScheduleItems"
      :lease-schedule-bulk-value.sync="leaseSchedulebulkValue"
      @submit="onBulkLinkBotSubmit"
      @contact-us="onContactFunctionalSupport"
    />

    <BulkActionUserDrawer
      v-if="isDrawerMounted('bulkactionuserdialog')"
      :visible="bulkactionuserdialog"
      @update:visible="bulkactionuserdialog = $event"
      :is-approver-editor-mode="isApproverEditorMode"
      :is-preparer-editor-mode="isPreparerEditorMode"
      :initial-approver-tab="approverEditorInitialTab"
      :bulk-action-user-type="bulkActionUserType"
      :selected-tasks="bulkApproverEditorTasks"
      :select-action.sync="selectaction"
      :bulk-action-user-id.sync="bulkactionuserid"
      :change-to-user.sync="changetouser"
      :action-items="bulkActionActionItems"
      :valid-active-users="validActiveUsers"
      :available-users="availableUsersForAssociate"
      :all-users="allActiveUsers"
      :saving="approverEditorSaving"
      :cycle-id="projectId"
      @action-change="onBulkActionSelectionChange"
      @remove="emitBulkManageUser('remove')"
      @associate="emitBulkManageUser('associate')"
      @replace="emitBulkManageUser('replace', bulkactionuserid, changetouser)"
      @move="emitBulkManageUser('move')"
      @update-user="emitBulkManageUser('update')"
      @save-approver-edit="onBulkApproverEditSave"
      @save-preparer-edit="onBulkPreparerEditSave"
    />

    <BulkUpdateDueDateDrawer
      v-if="isDrawerMounted('bulkduedatedialog')"
      :visible="bulkduedatedialog"
      :selected-tasks="selectedTasks"
      :due-date.sync="updatebulkduedate"
      :note.sync="bulkDueDateNote"
      :loading="bulkduedateloading"
      :min-date="dueDateMinDate"
      :max-date="dueDateMaxDate"
      :uses-cycle-end="dueDateValidationUsesCycleEnd"
      @update:visible="bulkduedatedialog = $event"
      @confirm="onBulkDueDateConfirm"
    />

    <BulkThresholdDrawer
      v-if="isDrawerMounted('bulkThresholdDialog')"
      :visible="bulkThresholdDialog"
      @update:visible="bulkThresholdDialog = $event"
      :loading="bulkThresholdLoading"
      :selected-tasks="selectedTasks"
      :enforce-threshold.sync="bulkEnforceThreshold"
      @cancel="bulkThresholdDialog = false"
      @confirm="onBulkThresholdConfirm"
    />

    <HelpdeskQueryDrawer
      v-if="isDrawerMounted('helpdeskdialog')"
      :visible="helpdeskdialog"
      @update:visible="helpdeskdialog = $event"
      :helpdesk-item="helpdeskitem"
      :ticket-description="helpdeskitem.__ticketdescripton || ''"
      @update:ticketDescription="$set(helpdeskitem, '__ticketdescripton', $event)"
      :helpdesk-item-new="helpdeskitemnew"
      :show-submit="metadata.stage === 0"
      @back-to-existing-tickets="helpdeskitemnew = false"
      @submit="onHelpdeskSubmit"
    />

    <LinkBotDrawer
      v-if="isDrawerMounted('linkbotdialog')"
      :visible="linkbotdialog"
      @update:visible="linkbotdialog = $event"
      :loading="linkbotloading"
      :bot-name="$constants.BOT_NAME"
      :selected-bot.sync="selectedbot"
      :bot-list="botList"
      :lease-schedule-items="leaseScheduleItems"
      :lease-schedule-value.sync="leaseScheduleValue"
      :transaction-matching-list="transactionMatchingList"
      :selected-transaction-matching.sync="selectedTransactionMatching"
      @link="onLinkBotSubmit"
      @contact-us="onContactFunctionalSupport"
    />

    <BulkWorkpaperUploadDrawer
      v-if="isDrawerMounted('bulkworkpaperupload')"
      :visible="bulkworkpaperupload"
      @update:visible="bulkworkpaperupload = $event"
      :files="workpaperFiles"
      @update:files="$emit('workpaper-files-change', $event)"
      :reset-trigger="workpaperResetTrigger"
      :workpaper-file-remark="workpaperFileRemark"
      @update:fileRemark="$emit('update:workpaperFileRemark', $event)"
      :file-names-list="workpaperFileNamesDisplay"
      :view-task-remark="viewTaskRemark"
      :view-task-remark-date="viewTaskRemarkDate"
      :upload-without-file="workpaperUploadWithoutFile"
      @update:uploadWithoutFile="$emit('update:workpaperUploadWithoutFile', $event)"
      @download-template="$emit('workpaper-download-template')"
      @download-file="$emit('workpaper-download-file', $event)"
      @submit-without-file="$emit('workpaper-submit-without-file')"
      @submit-with-files="$emit('workpaper-submit-with-files')"
    />

    <BulkChecklistUploadDrawer
      v-if="isDrawerMounted('bulkuploadtemplate')"
      :visible="bulkuploadtemplate"
      @update:visible="bulkuploadtemplate = $event"
      :loading="pageLoading"
      :upload-data="uploadData"
      :file="checklistUploadFile"
      @update:file="$emit('checklist-file-change', $event)"
      :reset-trigger="checklistResetTrigger"
      :show-data-with-error="checklistShowDataWithError"
      @update:showDataWithError="$emit('update:checklistShowDataWithError', $event)"
      :filtered-data="checklistFilteredData"
      :errorsonly="checklistErrorsOnly"
      :custom-columns="customColumns"
      :check-list-error-response="checkListErrorResponse"
      :has-validation-errors="checklistHasValidationErrors"
      @reupload="$emit('checklist-reupload')"
      @download-template="$emit('checklist-download-template')"
      @upload="$emit('checklist-upload')"
      @cancel="$emit('checklist-cancel')"
    />

    <BulkUpload
      v-if="isDrawerMounted('bulkEditDialog')"
      external
      external-mode="bulk-edit"
      test-id-prefix="tasklist-edit"
      :visible="bulkEditDialog"
      @update:visible="bulkEditDialog = $event"
      :busy="bulkEditLoading"
      :file-data-list="bulkEditFileDataList"
      :incoming-file="bulkEditFile"
      @update:file="$emit('bulk-edit-file-change', $event)"
      :reset-dropzone="bulkEditResetTrigger"
      :show-errors-only="bulkEditShowDataWithError"
      @update:showDataWithError="$emit('update:bulkEditShowDataWithError', $event)"
      :table-headers="bulkEditTableHeaders"
      :bulk-edit-filtered-data="bulkEditFilteredData"
      :row-errors="bulkEditRowErrors"
      :error-response="bulkEditErrorResponse"
      :has-file-data-error="bulkEditHasFileDataError"
      :has-validation-errors="bulkEditHasValidationErrors"
      :legacy-task-type-label-checklist-name="legacyTaskTypeLabelChecklistName"
      :legacy-task-type-label-checklist="legacyTaskTypeLabelChecklist"
      :get-names-by-ids="getNamesByIds"
      :get-location-by-id="getLocationById"
      @reupload="$emit('bulk-edit-reupload')"
      @download-template="$emit('bulk-edit-download-template')"
      @upload="$emit('bulk-edit-upload')"
      @cancel="$emit('bulk-edit-cancel')"
    />

    <TaskStatusReportDialog
      v-if="isDrawerMounted('statusReportVisible')"
      v-model="statusReportVisible"
      :status-details="statusDetails"
      :user-type="userType"
      data-testid="tasklist__all-task-status-report-dialog"
    />

    <div class="tasklist-upload-modals" data-testid="tasklist__upload-modals">
      <TaskUploadModal
        v-if="showSingleUpload"
        :key="'single-' + singleUploadSession"
        :modelValue="showSingleUpload"
        @update:modelValue="onSingleUploadVisibilityChange"
        :id="resolvedProjectId"
        :task="hasUploadTaskData ? uploadTaskData : {}"
        :filesOnly="false"
        :redesign="true"
        :auto-submit-on-upload="!isSingleUploadAccountRecon"
        @refresh="$emit('refresh')"
        data-testid="tasklist__upload-modal"
      />

      <TaskUploadModal
        v-if="showBulkUpload"
        :key="'bulk-' + bulkUploadSession"
        :modelValue="showBulkUpload"
        @update:modelValue="onBulkUploadVisibilityChange"
        :id="resolvedProjectId"
        :task="{ project: projectId }"
        :bulkworkpaper="true"
        :selectedTasks="resolvedBulkSelectedTasks"
        :filesOnly="false"
        :auto-submit-on-upload="!isBulkUploadAccountRecon"
        @clear-selected="$emit('clear-selected')"
        @refresh="$emit('refresh')"
        data-testid="tasklist__bulk-upload-modal"
      />
    </div>
  </div>
</template>

<script>
import BulkUpdateDueDateDrawer from './drawers/BulkUpdateDueDateDrawer/BulkUpdateDueDateDrawer.vue';
import BulkLinkBotDrawer from './drawers/BulkLinkBotDrawer/BulkLinkBotDrawer.vue';
import BulkActionUserDrawer from './drawers/BulkActionUserDrawer/BulkActionUserDrawer.vue';
import BulkThresholdDrawer from './drawers/BulkThresholdDrawer/BulkThresholdDrawer.vue';
import HelpdeskQueryDrawer from './drawers/HelpdeskQueryDrawer/HelpdeskQueryDrawer.vue';
import LinkBotDrawer from './drawers/LinkBotDrawer/LinkBotDrawer.vue';
import BulkWorkpaperUploadDrawer from './drawers/BulkWorkpaperUploadDrawer/BulkWorkpaperUploadDrawer.vue';
import BulkChecklistUploadDrawer from './drawers/BulkChecklistUploadDrawer/BulkChecklistUploadDrawer.vue';
import BulkUpload from '../../../components/BulkUpload/BulkUpload.vue';
import TaskUploadModal from '../TaskDetail/modals/TaskUploadModal.vue';
import TaskStatusReportDialog from '../components/TaskStatusReportDialog.vue';
import { attachInactiveLabel } from '../../../utils/tasklistUtils';
import { validateDueDateRange } from '../../../utils/utils';
import { getCycleDueDateWindow } from '../../../utils/workingDays';
import {
  ACTION_STAGE,
  APPROVER_TAG,
  MAX_DUE_DATE_DAYS,
  SIGN_OFF,
  USER_ROLE,
  USER_ROLE_LABEL,
} from '../../../utils/constants';
import {
  buildCycleBulkManageUserPayload,
  collectChecklistIdsFromSelectedTasks,
  syncCycleBulkApproverRoles,
  syncCycleBulkPreparerRoles,
} from '../../../utils/bulkApproverEditorUtils';
import {
  getPreparerBulkUploadBlockMessage,
  hasPreparerUploadBlocked,
  isAccountReconciliationTask,
  isBulkSelectionAccountReconciliation,
} from '../../../utils/tasklistHelpers';
import {
  activeUserIdsFromUserRoles,
  normalizeUserIdList,
} from '../../Setup/TaskList/utils/assignmentRoles';

function assignmentIdsFromTask(task, role, tag = null) {
  if (Array.isArray(task?.user_roles) && task.user_roles.length) {
    return activeUserIdsFromUserRoles(task.user_roles, role, tag);
  }
  if (role === USER_ROLE.PREPARER) return normalizeUserIdList(task?.preparer);
  if (role === USER_ROLE.APPROVER && tag === APPROVER_TAG.L2) {
    return normalizeUserIdList(task?.sign_off_approvers);
  }
  if (role === USER_ROLE.APPROVER) return normalizeUserIdList(task?.approver);
  return [];
}

/** Visibility flags whose drawer/dialog mounts on first open, then stays mounted. */
const LAZY_MOUNT_FLAGS = [
  'bulklinkbotdialog',
  'bulkactionuserdialog',
  'bulkduedatedialog',
  'bulkThresholdDialog',
  'helpdeskdialog',
  'linkbotdialog',
  'bulkworkpaperupload',
  'bulkuploadtemplate',
  'bulkEditDialog',
  'statusReportVisible',
];

export default {
  name: 'TasklistDrawers',
  components: {
    BulkUpdateDueDateDrawer,
    BulkLinkBotDrawer,
    BulkActionUserDrawer,
    BulkThresholdDrawer,
    HelpdeskQueryDrawer,
    LinkBotDrawer,
    BulkWorkpaperUploadDrawer,
    BulkChecklistUploadDrawer,
    BulkUpload,
    TaskUploadModal,
    TaskStatusReportDialog,
  },
  props: {
    projectId: { type: String, default: '' },
    metadata: { type: Object, default: () => ({}) },
    selectedTasks: { type: Array, default: () => [] },
    pageLoading: { type: Boolean, default: false },
    customColumns: { type: Array, default: () => [] },
    dueDateMinDate: { type: String, default: '' },
    dueDateMaxDate: { type: String, default: '' },
    userMap: { type: Object, default: () => ({}) },
    userDetails: { type: Object, default: () => ({ activeUsers: [], activeUserIds: [] }) },
    transactionMatchingList: { type: Array, default: () => [] },
    botList: { type: Array, default: () => [] },
    leaseScheduleItems: { type: Array, default: () => [] },
    getNamesByIds: { type: Function, default: () => () => [] },
    getLocationById: { type: Function, default: () => () => '' },
    workpaperFileNamesList: { type: Array, default: () => [] },
    legacyTaskTypeLabelChecklistName: { type: String, default: '' },
    legacyTaskTypeLabelChecklist: { type: String, default: '' },
    // Checklist bulk upload (state owned by shell)
    uploadData: { type: Array, default: () => [] },
    checklistUploadFile: { type: [Array, Object, null], default: null },
    checklistResetTrigger: { type: Boolean, default: false },
    checklistShowDataWithError: { type: Boolean, default: false },
    checklistFilteredData: { type: Array, default: () => [] },
    checklistErrorsOnly: { type: Array, default: () => [] },
    checkListErrorResponse: { type: String, default: '' },
    checklistHasValidationErrors: { type: Boolean, default: false },
    // Bulk edit (state owned by shell)
    bulkEditFileDataList: { type: Array, default: () => [] },
    bulkEditFile: { type: [Array, Object, null], default: null },
    bulkEditResetTrigger: { type: Boolean, default: false },
    bulkEditShowDataWithError: { type: Boolean, default: false },
    bulkEditTableHeaders: { type: Array, default: () => [] },
    bulkEditFilteredData: { type: Array, default: () => [] },
    bulkEditRowErrors: { type: Array, default: () => [] },
    bulkEditErrorResponse: { type: Array, default: () => [] },
    bulkEditHasFileDataError: { type: Boolean, default: false },
    bulkEditHasValidationErrors: { type: Boolean, default: false },
    bulkEditLoading: { type: Boolean, default: false },
    // Workpaper bulk upload
    workpaperFiles: { type: [Array, Object, null], default: null },
    workpaperResetTrigger: { type: Boolean, default: false },
    workpaperFileRemark: { type: String, default: '' },
    workpaperUploadWithoutFile: { type: Boolean, default: false },
    viewTaskRemark: { type: String, default: '' },
    viewTaskRemarkDate: { type: String, default: '' },
    locationList: { type: Array, default: () => [] },
    categoryAcc: { type: Array, default: () => [] },
    userType: { type: String, default: 'preparer' },
  },
  data() {
    return {
      statusReportVisible: false,
      showSingleUpload: false,
      showBulkUpload: false,
      singleUploadSession: 0,
      bulkUploadSession: 0,
      uploadTaskData: {},
      bulkUploadTasks: [],
      bulklinkbotdialog: false,
      bulklinkbotloading: false,
      bulkactionuserdialog: false,
      isApproverEditorMode: false,
      isPreparerEditorMode: false,
      approverEditorInitialTab: SIGN_OFF.EDITOR_TABS.APPROVER,
      approverEditorSaving: false,
      approverEditorContextTasks: [],
      bulkActionUserType: '',
      selectaction: '',
      bulkactionuserid: '',
      changetouser: '',
      possibleUsers: [],
      itemapprover: [
        { value: 'associate', name: 'Add' },
        { value: 'remove', name: 'Remove' },
        { value: 'replace', name: 'Replace' },
        { value: 'move', name: 'Change to Preparer' },
      ],
      itempreparer: [
        { value: 'associate', name: 'Add' },
        { value: 'remove', name: 'Remove' },
        { value: 'replace', name: 'Replace' },
        { value: 'move', name: 'Change to Approver' },
      ],
      itemsignoffapprover: [
        { value: 'associate', name: 'Add' },
        { value: 'remove', name: 'Remove' },
        { value: 'replace', name: 'Replace' },
      ],
      bulkduedatedialog: false,
      bulkduedateloading: false,
      updatebulkduedate: '',
      bulkDueDateNote: '',
      bulkThresholdDialog: false,
      bulkThresholdLoading: false,
      bulkEnforceThreshold: true,
      helpdeskdialog: false,
      helpdeskitem: {},
      helpdeskitemnew: false,
      linkbotdialog: false,
      linkbotloading: false,
      linkTask: {},
      bulkLinkTaskMap: {},
      selectedbot: '',
      botSelecetedId: '',
      leaseScheduleValue: [],
      leaseSchedulebulkValue: {},
      selectedTransactionMatching: '',
      bulkworkpaperupload: false,
      bulkuploadtemplate: false,
      bulkEditDialog: false,
      openedDrawers: {},
    };
  },
  created() {
    // Kept mounted after the first open so close animations and in-drawer state survive.
    LAZY_MOUNT_FLAGS.forEach((flag) => {
      this.$watch(flag, (isOpen) => {
        if (isOpen && !this.openedDrawers[flag]) this.$set(this.openedDrawers, flag, true);
      });
    });
  },
  computed: {
    resolvedProjectId() {
      return this.projectId?.length ? this.projectId : (this.metadata?._id || 'dummy');
    },
    /** True when cycle end metadata drives the due-date window (not today + max days fallback). */
    dueDateValidationUsesCycleEnd() {
      return getCycleDueDateWindow(this.metadata?.to, MAX_DUE_DATE_DAYS).usesCycleEnd;
    },
    bulkApproverEditorTasks() {
      if (this.approverEditorContextTasks.length) {
        return this.approverEditorContextTasks;
      }
      return this.selectedTasks;
    },
    bulkActionActionItems() {
      if (this.bulkActionUserType === SIGN_OFF.APPROVER_LABEL) {
        return this.itemsignoffapprover;
      }
      if (this.bulkActionUserType === USER_ROLE_LABEL.APPROVER) {
        return this.itemapprover;
      }
      return this.itempreparer;
    },
    hasUploadTaskData() {
      return this.uploadTaskData && Object.keys(this.uploadTaskData).length > 0;
    },
    resolvedBulkSelectedTasks() {
      return this.bulkUploadTasks.length > 0 ? this.bulkUploadTasks : this.selectedTasks;
    },
    isSingleUploadAccountRecon() {
      return isAccountReconciliationTask(this.hasUploadTaskData ? this.uploadTaskData : {});
    },
    isBulkUploadAccountRecon() {
      return isBulkSelectionAccountReconciliation(this.resolvedBulkSelectedTasks);
    },
    statusDetails() {
      return this.$store.getters['tasks/getStatusDetails'];
    },
    validActiveUsers() {
      if (this.selectaction === ACTION_STAGE.REMOVE_USER || this.selectaction === ACTION_STAGE.REPLACE_USER) {
        return attachInactiveLabel(this.possibleUsers, this.userDetails.activeUserIds);
      }
      if (this.selectaction === ACTION_STAGE.MOVE_USER) {
        return this.possibleUsers?.filter((user) => this.userDetails.activeUserIds.includes(user._id));
      }
      return [];
    },
    availableUsersForAssociate() {
      const users = Object.values(this.userMap);
      if (users.length === 0) return [];
      return users.filter(
        (u) => !this.possibleUsers.some((pu) => pu._id === u._id)
          && this.userDetails.activeUserIds.includes(u._id)
      );
    },
    allActiveUsers() {
      const activeIds = new Set(this.userDetails.activeUserIds || []);
      return Object.values(this.userMap).filter((user) => user?._id && activeIds.has(user._id));
    },
    workpaperFileNamesDisplay() {
      return (this.workpaperFileNamesList || []).map((v) => ({
        ...v,
        formattedDate: this.$nova.formatDate(v.date),
      }));
    },
  },
  watch: {
    selectedbot(botName) {
      this.botSelecetedId = '';
      if (!botName || (Array.isArray(botName) && botName.length === 0)) return;
      const name = Array.isArray(botName) ? botName[0] : botName;
      this.$emit('page-loading-change', true);
      this.axios
        .post('/v2/bot/analysis/getbotidbyname', { data: [{ name }] })
        .then((dt) => {
          if (dt.data.status === 'success') {
            this.botSelecetedId = dt.data.data[0]._id;
          }
        })
        .catch((err) => {
          console.log('[TasklistDrawers]: getbotidbyname error', err);
        })
        .finally(() => {
          this.$emit('page-loading-change', false);
        });
    },
  },
  methods: {
    isDrawerMounted(flag) {
      return !!(this[flag] || this.openedDrawers[flag]);
    },
    onContactFunctionalSupport() {
      this.$nova.gotoLink({
        path: '/financialclose/functionalsupport/' + this.metadata._id,
      });
    },
    openHelpdesk(task) {
      this.helpdeskitem = { ...task };
      this.helpdeskdialog = true;
      this.helpdeskitemnew = false;
      this.$store.dispatch('tasks/fetchHelpdeskExistingTickets', {
        checklistId: this.metadata._id,
        taskId: this.helpdeskitem._id,
      })
        .then((result) => {
          if (result.success) {
            this.helpdeskitem.__existingtickets = result.tickets || [];
            if ((this.helpdeskitem.__existingtickets || []).length === 0) {
              this.helpdeskitemnew = true;
            }
          }
        })
        .catch((err) => {
          this.$store.commit('sbError', err.message || err || 'Unknown error!');
          console.log('[TasklistDrawers]: fetchHelpdeskExistingTickets error', err);
        });
    },
    async onHelpdeskSubmit() {
      const result = await this.$store.dispatch('tasks/addHelpdeskQuery', {
        checklistId: this.metadata._id,
        taskId: this.helpdeskitem._id,
        issue: this.helpdeskitem.description,
        description: this.helpdeskitem.__ticketdescripton,
        modulename: this.$route.meta.modulename,
      });
      if (result.success && result.ticket) {
        this.$store.commit('sbSuccess', 'Ticket raised');
        this.helpdeskdialog = false;
        this.$nova.gotoLink({
          path: '/financialclose/functionalsupport/' + this.metadata._id + '/support/' + result.ticket._id,
        });
      }
    },
    openLinkBot(task) {
      this.linkTask = { ...task };
      this.selectedbot = task.botid || '';
      this.linkbotdialog = true;
      this.leaseScheduleValue = [];
      this.selectedTransactionMatching = '';
      this.$store.dispatch('tasks/fetchTransactionMatchingAnalysis', { checklistId: this.projectId }).catch(() => {});
    },
    async onLinkBotSubmit() {
      if (!this.selectedbot || !this.linkTask._id) {
        this.$store.commit('sbError', 'Please select an ' + this.$constants.BOT_NAME + ' and task.');
        return;
      }
      const link = {
        botid: this.botSelecetedId,
        task_id: this.linkTask._id,
        bot_result_tags: [],
      };
      if (this.selectedbot === 'Lease Schedule') {
        link.bot_result_tags = this.leaseScheduleValue;
      }
      if (this.selectedbot === 'Transaction Matching') {
        link.tmaid = this.selectedTransactionMatching;
      }
      this.linkbotloading = true;
      try {
        const result = await this.$store.dispatch('tasks/linkBotTasks', {
          checklistId: this.projectId,
          links: [link],
        });
        if (result.success) {
          this.$store.commit('sbSuccess', this.$constants.BOT_NAME + ' Linked');
          this.linkbotdialog = false;
          this.selectedbot = '';
          this.botSelecetedId = '';
          this.selectedTransactionMatching = '';
          this.leaseScheduleValue = [];
          this.linkTask = {};
          this.$emit('refresh');
        }
      } finally {
        this.linkbotloading = false;
      }
    },
    openBulkLinkBot(taskMap) {
      this.bulkLinkTaskMap = { ...taskMap };
      this.selectedbot = '';
      this.bulklinkbotdialog = true;
      this.leaseSchedulebulkValue = {};
    },
    async onBulkLinkBotSubmit() {
      try {
        this.bulklinkbotloading = true;
        const links = Object.keys(this.bulkLinkTaskMap).map((key) => ({
          botid: this.selectedbot,
          task_id: this.bulkLinkTaskMap[key],
          bot_result_tags: this.leaseSchedulebulkValue[this.bulkLinkTaskMap[key]] || [],
        }));
        const result = await this.$store.dispatch('tasks/linkBotTasks', {
          checklistId: this.projectId,
          links,
        });
        if (result.success) {
          this.$store.commit('sbSuccess', `Bulk ${this.$constants.BOT_NAME} Linked`);
          this.bulklinkbotdialog = false;
          this.leaseSchedulebulkValue = {};
          this.selectedbot = '';
          this.bulkLinkTaskMap = {};
          this.$emit('refresh');
        }
      } catch (err) {
        console.error('[TasklistDrawers]: bulklinkBot error', err);
      } finally {
        this.bulklinkbotloading = false;
      }
    },
    openBulkActionUser(type) {
      this.selectaction = '';
      this.approverEditorContextTasks = [];
      if (type === USER_ROLE.PREPARER || type === USER_ROLE_LABEL.PREPARER) {
        this.isApproverEditorMode = false;
        this.isPreparerEditorMode = true;
        this.bulkActionUserType = USER_ROLE_LABEL.PREPARER;
        this.bulkactionuserdialog = true;
        return;
      }
      if (type === USER_ROLE.APPROVER || type === USER_ROLE.SIGN_OFF_APPROVER) {
        this.isPreparerEditorMode = false;
        this.isApproverEditorMode = true;
        this.approverEditorInitialTab = type === USER_ROLE.SIGN_OFF_APPROVER
          ? SIGN_OFF.EDITOR_TABS.SIGN_OFF
          : SIGN_OFF.EDITOR_TABS.APPROVER;
        this.bulkActionUserType = USER_ROLE_LABEL.APPROVER;
        this.bulkactionuserdialog = true;
        return;
      }
      this.isApproverEditorMode = false;
      this.isPreparerEditorMode = false;
      this.prepareBulkActionUsers(type);
    },
    openRowApproverEditor(task) {
      if (!task?._id) return;
      this.selectaction = '';
      this.approverEditorContextTasks = [task];
      this.isPreparerEditorMode = false;
      this.isApproverEditorMode = true;
      this.approverEditorInitialTab = SIGN_OFF.EDITOR_TABS.APPROVER;
      this.bulkActionUserType = USER_ROLE_LABEL.APPROVER;
      this.bulkactionuserdialog = true;
    },
    prepareBulkActionUsers(type) {
      this.possibleUsers = [];
      if (!type) return;
      const userSet = new Set();
      if (type === USER_ROLE.PREPARER || type === USER_ROLE_LABEL.PREPARER) {
        this.bulkActionUserType = USER_ROLE_LABEL.PREPARER;
        this.selectedTasks.forEach((task) => {
          assignmentIdsFromTask(task, USER_ROLE.PREPARER).forEach((uid) => userSet.add(uid));
        });
      } else if (type === USER_ROLE.APPROVER || type === USER_ROLE_LABEL.APPROVER) {
        this.bulkActionUserType = USER_ROLE_LABEL.APPROVER;
        this.selectedTasks.forEach((task) => {
          assignmentIdsFromTask(task, USER_ROLE.APPROVER, APPROVER_TAG.L1)
            .forEach((uid) => userSet.add(uid));
        });
      } else if (type === USER_ROLE.SIGN_OFF_APPROVER) {
        this.bulkActionUserType = SIGN_OFF.APPROVER_LABEL;
        this.selectedTasks.forEach((task) => {
          assignmentIdsFromTask(task, USER_ROLE.APPROVER, APPROVER_TAG.L2)
            .forEach((uid) => userSet.add(uid));
        });
      }
      this.possibleUsers = [...userSet].map((id) => this.userMap[id]).filter(Boolean);
      this.bulkactionuserdialog = true;
    },
    async onBulkPreparerEditSave({ preparerIds, checklistIds }) {
      const editorTasks = this.bulkApproverEditorTasks;
      const resolvedChecklistIds = checklistIds?.length
        ? checklistIds.map(String)
        : collectChecklistIdsFromSelectedTasks(editorTasks);

      if (!resolvedChecklistIds.length) return;

      this.approverEditorSaving = true;

      try {
        await syncCycleBulkPreparerRoles({
          checklistIds: resolvedChecklistIds,
          selectedTasks: editorTasks,
          preparerIds,
          manageUser: (payload) => this.bulkManageUserCall(payload),
        });
        this.$store.commit('sbSuccess', 'Preparer updated');
        this.closeBulkActionUser();
        this.$emit('update:selectedTasks', []);
        this.$emit('refresh');
      } catch (err) {
        this.$store.commit('sbError', err?.message || 'Unable to update preparers');
      } finally {
        this.approverEditorSaving = false;
      }
    },
    async onBulkApproverEditSave({ approverIds, signOffIds, checklistIds }) {
      const editorTasks = this.bulkApproverEditorTasks;
      const resolvedChecklistIds = checklistIds?.length
        ? checklistIds.map(String)
        : collectChecklistIdsFromSelectedTasks(editorTasks);

      if (!resolvedChecklistIds.length) return;

      const isRowApproverEdit = this.approverEditorContextTasks.length > 0;
      this.approverEditorSaving = true;

      try {
        await syncCycleBulkApproverRoles({
          checklistIds: resolvedChecklistIds,
          selectedTasks: editorTasks,
          approverIds,
          signOffIds,
          manageUser: (payload) => this.bulkManageUserCall(payload),
        });
        this.$store.commit('sbSuccess', 'Approver updated');
        this.closeBulkActionUser();
        if (!isRowApproverEdit) {
          this.$emit('update:selectedTasks', []);
        }
        this.$emit('refresh');
      } catch (err) {
        if (err?.partialSuccess) {
          this.$store.commit('sbWarning', err?.message || 'Some approver updates could not be applied');
          this.closeBulkActionUser();
          if (!isRowApproverEdit) {
            this.$emit('update:selectedTasks', []);
          }
          this.$emit('refresh');
        } else {
          this.$store.commit('sbError', err?.message || 'Unable to update approvers');
        }
      } finally {
        this.approverEditorSaving = false;
      }
    },
    async bulkManageUserCall({ action, usertype, userId, checklistIds }) {
      const response = await this.axios.post(
        `/v2/financialclose/analysis/bulkmanageuser/${this.projectId}`,
        buildCycleBulkManageUserPayload({
          checklistIds,
          usertype,
          userId,
          action,
        })
      );
      if (response?.data?.status !== 'success') {
        throw new Error(response?.data?.message || 'Error updating users');
      }
    },
    onBulkActionSelectionChange() {
      if (this.selectaction === 'remove') {
        this.prepareBulkActionUsers(this.bulkActionUserType);
      } else {
        this.prepareBulkActionUsers(this.bulkActionUserType);
      }
    },
    emitBulkManageUser(actionOverride, userIdOverride, changeUserOverride) {
      const action = actionOverride || this.selectaction;
      let usertype = this.bulkActionUserType;
      if (usertype === SIGN_OFF.APPROVER_LABEL) {
        usertype = 'sign_off_approver';
      } else {
        usertype = (usertype || '').toLowerCase();
      }
      let userid = this.bulkactionuserid;
      let changeuserid = changeUserOverride;
      if (action === 'associate') {
        userid = this.changetouser;
      } else if (action === 'replace') {
        userid = this.bulkactionuserid;
        changeuserid = this.changetouser;
      } else if (action === 'move') {
        usertype = this.bulkActionUserType === 'Preparer' ? 'approver' : 'preparer';
      } else if (userIdOverride !== undefined) {
        userid = userIdOverride;
      }
      this.$emit('bulk-manage-user', {
        action,
        usertype,
        userid,
        changeuserid,
        selectitems: this.selectedTasks,
      });
    },
    closeBulkActionUser() {
      this.bulkactionuserdialog = false;
      this.isApproverEditorMode = false;
      this.isPreparerEditorMode = false;
      this.approverEditorContextTasks = [];
      this.changetouser = '';
    },
    openBulkDueDate() {
      this.updatebulkduedate = '';
      this.bulkDueDateNote = '';
      this.bulkduedatedialog = true;
      this.bulkduedateloading = false;
    },
    toBulkDueDatePayload(value) {
      if (!value) return '';
      if (typeof value === 'string') {
        const isoMatch = value.trim().match(/^(\d{4}-\d{2}-\d{2})/);
        if (isoMatch) return isoMatch[1];
        const dmyMatch = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (dmyMatch) {
          return `${dmyMatch[3]}-${dmyMatch[2].padStart(2, '0')}-${dmyMatch[1].padStart(2, '0')}`;
        }
      }
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async onBulkDueDateConfirm() {
      const dueDate = this.toBulkDueDatePayload(this.updatebulkduedate);
      if (dueDate) {
        const dueDateResult = validateDueDateRange(dueDate, MAX_DUE_DATE_DAYS, {
          minDate: this.dueDateMinDate,
          maxDate: this.dueDateMaxDate,
          usesCycleEnd: this.dueDateValidationUsesCycleEnd,
        });
        if (!dueDateResult.valid) {
          this.$store.commit('sbError', dueDateResult.error);
          return;
        }
      }
      this.bulkduedateloading = true;
      this.$emit('page-loading-change', true);
      let refreshList = false;
      try {
        const result = await this.$store.dispatch('tasks/bulkUpdateDueDate', {
          cycleId: this.projectId,
          taskIds: this.selectedTasks.map((item) => item._id),
          duedate: dueDate,
          note: this.bulkDueDateNote || undefined,
        });
        if (result.success) {
          this.$emit('update:selectedTasks', []);
          this.bulkduedatedialog = false;
          refreshList = true;
        }
      } finally {
        this.bulkduedateloading = false;
        this.$emit('page-loading-change', false);
      }
      // Full checklist reload (getAllTasks). refreshData sets TasksLandingPage.loading,
      // which is the table skeleton, and clears it when that reload finishes or fails.
      // Emit after the request lock is released so this false does not clear that flag.
      if (refreshList) {
        this.$emit('refresh');
      }
    },
    openBulkThreshold() {
      this.bulkEnforceThreshold = true;
      this.bulkThresholdDialog = true;
    },
    async onBulkThresholdConfirm() {
      if (this.selectedTasks.length === 0) return;
      this.bulkThresholdLoading = true;
      try {
        const result = await this.$store.dispatch('tasks/bulkUpdateEnforceThreshold', {
          cycleId: this.projectId,
          taskIds: this.selectedTasks.map((item) => item._id),
          enforceThreshold: this.bulkEnforceThreshold,
          client: this.$store.state.client,
        });
        if (result.success) {
          this.bulkThresholdDialog = false;
          this.$emit('refresh');
        }
      } finally {
        this.bulkThresholdLoading = false;
      }
    },
    openBulkEdit() {
      this.bulkEditDialog = true;
      this.$emit('bulk-edit-open');
    },
    closeBulkEdit() {
      this.bulkEditDialog = false;
    },
    openBulkWorkpaperUpload() {
      this.bulkworkpaperupload = true;
    },
    closeBulkWorkpaperUpload() {
      this.bulkworkpaperupload = false;
    },
    openBulkChecklistUpload() {
      this.bulkuploadtemplate = true;
    },
    closeBulkChecklistUpload() {
      this.bulkuploadtemplate = false;
    },
    openSingleUpload(task) {
      this.uploadTaskData = task ? { ...task } : {};
      this.showSingleUpload = true;
    },
    openBulkUpload(task) {
      this.bulkUploadTasks = task ? [task] : [];
      this.showBulkUpload = true;
    },
    openBulkWorkpaperUploadModal() {
      if (!Array.isArray(this.selectedTasks) || this.selectedTasks.length === 0) {
        this.$store.commit('sbError', 'Select at least one task.');
        return;
      }

      if (hasPreparerUploadBlocked(this.selectedTasks)) {
        this.$store.commit(
          'sbError',
          getPreparerBulkUploadBlockMessage(this.selectedTasks),
        );
        return;
      }
      this.bulkUploadTasks = [];
      this.showBulkUpload = true;
    },
    closeBulkUploadModal() {
      this.showBulkUpload = false;
    },
    onSingleUploadVisibilityChange(value) {
      this.showSingleUpload = value;
      if (!value) {
        this.singleUploadSession += 1;
        this.uploadTaskData = {};
      }
    },
    onBulkUploadVisibilityChange(value) {
      this.showBulkUpload = value;
      if (!value) {
        this.bulkUploadSession += 1;
        this.bulkUploadTasks = [];
      }
    },
    openStatusReport() {
      this.statusReportVisible = true;
    },
  },
};
</script>
